import Equifax from "../../assets/company-logos/Equifax.png";
import FullContact from "../../assets/company-logos/FullContact.png";
import Experian from "../../assets/company-logos/Experian.png";
import Acxiom from "../../assets/company-logos/Acxiom.png";
import DataAxle from "../../assets/company-logos/dataaxle.png";
import L2 from "../../assets/company-logos/L2.png";
import PeopleDataLabs from "../../assets/company-logos/PDL.png";
import Epsilon from "../../assets/company-logos/Epsilon.png";
import PIPL from "../../assets/company-logos/pipl.svg";
import Attom from "../../assets/company-logos/Attom.png";

const data = {
  usecaseInfo: {
    name: "Optimize Portfolio Monitoring",
    description:
      "A single platform to enrich customer profiles for retention and cross-sell intiatives",
  },
  recipesInfo: {
    title: "Maximize Customer Revenue",
    description:
      "Access API-ready solutions for customer profile data enrichment to enable effective segmentation and scoring for improved retention risk modeling and cross-sell activities.",
  },
  recipes: [
    {
      type: "People Data",
      title: "Personal Habits and Life Risks",
      description: "Gather details about an individual's lifestyle and lifestage.",
    },
    {
      type: "People Data",
      title: "Property Ownership and Occupancy",
      description:
        "Obtain occupancy status of a residence, as well as characteristics about the owner.",
    },
    {
      type: "Business Data",
      title: "Business Firmographics",
      description:
        "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details.",
    },
    {
      type: "Business Data",
      title: "Business Prefill Growth Indicators",
      description:
        "Provides growth trigger attributes and other informative data about a business.",
    },
    {
      type: "Business Data",
      title: "Email Leads",
      description:
        "Pulls employee contact email & role information based off employee name & name of employer.",
    },
    {
      type: "People Data",
      title: "Business Email Screening",
      description:
        "Pulls employee and employer details and provides email risk related information for screening.",
    },
    {
      type: "People Data",
      title: "Personal Habits and Life Risks",
      description: "Gather details about an individual's lifestyle and lifestage.",
    },
    {
      type: "People Data",
      title: "Property Ownership and Occupancy",
      description:
        "Obtain occupancy status of a residence, as well as characteristics about the owner.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],

  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "FullContact",
        img: FullContact,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "Acxiom",
        img: Acxiom,
      },
      {
        name: "DataAxle",
        img: DataAxle,
      },
      {
        name: "L2",
        img: L2,
      },
      {
        name: "PeopleDataLabs",
        img: PeopleDataLabs,
      },
      {
        name: "Epsilon",
        img: Epsilon,
      },
      {
        name: "PIPL",
        img: PIPL,
      },
      {
        name: "Attom",
        img: Attom,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Going Deeper than Tax Assessor Data for Marketing",
      url: "https://demyst.com/blog/residential-property-data-can-improve-marketing-decisions",
      featured_image: "https://cdn.buttercms.com/I47WHpIISgWGfK7myYcK",
      date: "2021-10-14",
      description:
        "Tax assessor data provides a wealth of information, including property ownership, assessed value, and property characteristics (e.g., number of floors, presence of a fireplace). However, it suffers from three major issues: ",
      more: "",
    },
    {
      title: 'Leveraging External Data to Identify "Breakout SMBs"',
      url: "https://demyst.com/blog/leveraging-external-data-to-identify-breakout-smbs",
      featured_image: "https://cdn.buttercms.com/lQDH0KAdTZGX6pQwSpTl",
      date: "2020-05-27",
      description:
        "Small businesses (“SMBs”) are the world’s primary economic engine. According to World Bank estimates these firms represents 90% of businesses globally, and more than 50% of employment worldwide. During economic upswings, these enterprises multiply, grow, and provide vital sources of revenue not just for their employees, but also for utilities and telcos, advertising, lending, insurance, and a host of other large corporate entities. During downswings, small businesses are the first to get pinched, as consumers have less discretionary income and immediately trim their spending (with panic buying as an exception during crises). In both cycles, the ripple effects to small businesses have massive outsized impact.",
      more: "",
    },
    {
      title: "Predicting Customer Trajectory with External Data",
      url: "https://demyst.com/blog/predicting-customer-trajectory-with-external-data",
      featured_image: "https://cdn.buttercms.com/yen3Ku8cSkGvX4fYqPFL",
      date: "2020-07-24",
      description:
        "As unemployment soars to historic highs, risk professionals are seeking to predict the financial trajectory of their customers in order to mitigate losses and inform go-to-market strategies.",
      more: "",
    },
  ],
};

export default data;
